module.exports = __webpack_public_path__ + "img/ic_cogs.ba247941.svg";